/*
  Court Vibes, 25.09.2026.
  Laufband in der Ankuendigungsleiste, eingebunden aus layout/theme.liquid.

  Horizon zeigt mehrere Ankuendigungen als Schieber mit Pfeilen. Houda wollte
  ein durchlaufendes Band wie die Marquee-Section weiter unten. Der Schieber
  wird deshalb ausgeblendet und aus denselben Texten ein Band gebaut. Die
  Texte bleiben im Theme-Editor pflegbar, am Inhalt wird nichts geaendert.

  WICHTIG, am 25.09.2026 teuer gelernt, bitte nicht wieder versuchen:
  Diese Datei fasst das Newsletter-Formular in der Fusszeile NICHT an.
  Der Versuch, die Anmeldung per fetch an /contact zu schicken, sah auf dem
  Bildschirm richtig aus, hat aber keinen einzigen Kunden angelegt, Shopify
  antwortet auf fetch mit 400. Shopify legt einen Newsletter-Kunden nur bei
  einem echten Formular-POST an, also mit Neuladen der Seite. Das Neuladen
  ist der Preis dafuer, dass die Anmeldung wirklich ankommt.
  Der Kommentar in layout/theme.liquid, der von einer Anmeldung ohne
  Neuladen spricht, ist aus diesem Grund ueberholt.
*/
(function () {
  var css = [
    'body { --cv-laufband: on; }',
    '.cv-laufband { overflow: hidden; width: 100%; }',
    '.cv-laufband__spur { display: flex; width: max-content; animation: cv-laufband-lauf 30s linear infinite; }',
    '.cv-laufband__gruppe { display: flex; align-items: center; }',
    '.cv-laufband__text { white-space: nowrap; text-decoration: none; color: inherit; font-size: 0.875rem; }',
    '.cv-laufband__text:hover { text-decoration: underline; }',
    '.cv-laufband__punkt { margin: 0 1.75rem; opacity: 0.55; }',
    '.cv-laufband:hover .cv-laufband__spur, .cv-laufband:focus-within .cv-laufband__spur { animation-play-state: paused; }',
    '@keyframes cv-laufband-lauf { from { transform: translateX(0); } to { transform: translateX(-50%); } }',
    '@media (prefers-reduced-motion: reduce) { .cv-laufband__spur { animation: none; } }'
  ].join('\n');

  function stilSetzen() {
    if (document.getElementById('cv-laufband-stil')) return;
    var s = document.createElement('style');
    s.id = 'cv-laufband-stil';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function laufbandBauen() {
    var leiste = document.querySelector('.announcement-bar');
    if (!leiste || leiste.getAttribute('data-cv-laufband')) return;
    var folien = Array.prototype.slice.call(leiste.querySelectorAll('.announcement-bar__slide'));
    if (!folien.length) return;

    var eintraege = [];
    folien.forEach(function (folie) {
      var absatz = folie.querySelector('p');
      var text = (absatz ? absatz.textContent : folie.textContent) || '';
      text = text.replace(/\s+/g, ' ').trim();
      if (!text) return;
      var link = folie.querySelector('a');
      eintraege.push({ text: text, href: link ? link.getAttribute('href') : '' });
    });
    if (!eintraege.length) return;

    var schieber = leiste.querySelector('announcement-bar-component') || leiste.querySelector('.announcement-bar__slider');
    if (schieber) schieber.style.display = 'none';

    function gruppe() {
      var g = document.createElement('div');
      g.className = 'cv-laufband__gruppe';
      eintraege.forEach(function (e) {
        var el;
        if (e.href) {
          el = document.createElement('a');
          el.setAttribute('href', e.href);
        } else {
          el = document.createElement('span');
        }
        el.className = 'cv-laufband__text';
        el.textContent = e.text;
        g.appendChild(el);
        var punkt = document.createElement('span');
        punkt.className = 'cv-laufband__punkt';
        punkt.setAttribute('aria-hidden', 'true');
        punkt.textContent = '•';
        g.appendChild(punkt);
      });
      return g;
    }

    var band = document.createElement('div');
    band.className = 'cv-laufband';
    var spur = document.createElement('div');
    spur.className = 'cv-laufband__spur';
    spur.appendChild(gruppe());
    var zweite = gruppe();
    zweite.setAttribute('aria-hidden', 'true');
    spur.appendChild(zweite);
    band.appendChild(spur);
    leiste.appendChild(band);
    leiste.setAttribute('data-cv-laufband', 'on');

    window.requestAnimationFrame(function () {
      var breite = spur.scrollWidth / 2;
      if (!breite) return;
      var dauer = Math.max(18, Math.round(breite / 55));
      spur.style.animationDuration = dauer + 's';
    });
  }

  function start() {
    stilSetzen();
    laufbandBauen();
    var beobachter = new MutationObserver(function () { laufbandBauen(); });
    beobachter.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { beobachter.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
